import api from "../api";

class ProviderService {
    async getAllProviders() {
        return new Promise((res, reject) => {
            api
                .get("/provider")
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getProviderById(id) {
        return new Promise((res, reject) => {
            api
                .get("/provider/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async createProvider(obj) {
        return new Promise((res, reject) => {
            api
                .post("/provider", obj)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async updateProvider(obj) {
        return new Promise((res, reject) => {
            api
                .put("/provider", obj)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async deleteProvider(id) {
        return new Promise((res, rej) => {
            return api.delete('/provider/' + id).then(data => {
                res();
            }).catch(err => {
                rej();
            });
        });
    }
}

const providerService = new ProviderService();

export default providerService;
